export function paymentMethodsBuilderUI(methods) {
  return methods.map(method => {
    return {
      ...method
    };
  });
}

export function preOrderBuilderUI(value) {
  return {
    ...value
  };
}
